import { Layout } from 'antd'
import { useStore } from '../../store/basic-store'
import { User } from '../../types'
import { useOnLoad } from '../../hooks/lifecycle'
import { useNavigate, useParams } from 'react-router-dom'

export function TradewarsGame() {
  const user = useStore<User>('user')
  const nav = useNavigate()
  const { id } = useParams()
  const game = useStore<TradewarsGameInterface>(`game-${id}`)
  // Initialize game state
  // Check for universe
  // Check for player
  // Check for starting empires

  useOnLoad(() => {
    if (!user) {
      // Redirect to login or show an error
      console.error('User not logged in')
      nav('/')
    }
    console.log('id: ', id)
  })
  return (
    <Layout>
      <h1>Tradewars Empires</h1>
      <p>This is the game interface for Tradewars.</p>
      {/* Additional game components and logic would go here */}
    </Layout>
  )
}
